import './search-featured-card.scss'

import { faCircleNotch } from '@fortawesome/free-solid-svg-icons'
import { faDotCircle, faExternalLinkAlt } from '@fortawesome/free-solid-svg-icons'
import { Component, Watch } from 'vue-property-decorator'

import { ReactiveVue } from '@skinsoft/reactive-vue'
import { States, TitleClickAction } from '@skinsoft/ui'

import { SearchResult } from '@skinsoft/entity'
import { getReadableDate } from '../date-helper'
import { Author } from '../item-card/description/author'
import { Media } from '../item-card/media'
import { Touchable } from '../touchable'

interface Credits {
    alias: string
    authorFunction: string
}

export interface SearchFeatured {
    itemId: string
    itemType: string
    workId: string
    manifestationId: string
    expressionId: string

    creation_date: string
    credits: Credits
    institution: string
    lastConditionReportId: any
    lastDateOfConditionReport: string
    media: string
    title: string
    domain: string
    denomination: string
    inventoryNumber: string
    materialAndTechniques: any
    measurements: any
    weight: any
}

export const SEARCH_FEATURED_CARD_TITLE_CLICKED = 'search-featured-card-title-clicked'

@Component({
    components: {
        sAuthor: Author,
        sMedia: Media,
        sTouchable: Touchable,
    },
    props: ['searchFeatured', 'rounded', 'targetRouteName', 'hasLastReport', 'titleClickAction'],
    template: require('./search-featured-card.html'),
})
export class SearchFeaturedCard extends ReactiveVue {
    public loadingIcon = faCircleNotch
    public editIcon = faExternalLinkAlt

    public searchFeatured: SearchFeatured
    public rounded: boolean
    public hasLastReport: boolean
    private titleClickAction: TitleClickAction

    public circleIcon = faDotCircle
    public state: States = States.PENDING

    public targetRouteName: string

    // Item data
    public authorFunction: string = ''
    public searchresult: SearchResult = null as any

    @Watch('searchFeatured', { immediate: true, deep: true })
    public onItemChange(searchFeatured: SearchFeatured) {
        this.state = searchFeatured ? States.READY : States.PENDING
    }

    public isReady() {
        return this.state === States.READY
    }

    public get shouldDisplayAuthorFunction(): boolean {
        const credits = this.searchFeatured.credits
        return !!credits && !!credits.alias && !!credits.authorFunction
    }

    public get lastReportDate() {
        return getReadableDate(this.searchFeatured.lastDateOfConditionReport)
    }

    public onTitleClicked() {
        if (this.titleClickAction) {
            this.$emit(SEARCH_FEATURED_CARD_TITLE_CLICKED)
        }
    }
}
